import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { CompetitionStageDto, PortalLifecycleStatus } from "../../../../autogen/bff-api";

// Labels are looked up dynamically by status, so langen can't see them statically:
// t("Open for bids") t("Open for entries") t("Open for requests") t("Open for expressions of interest") t("Qualification in progress") t("Deadline passed")
// t("Under evaluation") t("Awarded") t("Cancelled_competition") t("Concluded")
const META: Record<PortalLifecycleStatus, { color: string; key: string }> = {
  [PortalLifecycleStatus.Open]: { color: "green", key: "Open for bids" },
  [PortalLifecycleStatus.DeadlinePassed]: { color: "orange", key: "Deadline passed" },
  [PortalLifecycleStatus.UnderEvaluation]: { color: "blue", key: "Under evaluation" },
  [PortalLifecycleStatus.Awarded]: { color: "purple", key: "Awarded" },
  [PortalLifecycleStatus.Cancelled]: { color: "gray", key: "Cancelled_competition" },
  [PortalLifecycleStatus.Concluded]: { color: "gray", key: "Concluded" },
};

export const PortalLifecycleTag = ({
  status,
  stage,
  size = "sm",
  designContest = false,
}: {
  status: PortalLifecycleStatus;
  // Two-stage competitions are "open" for requests long before any bidding exists.
  stage?: CompetitionStageDto | null;
  size?: "sm" | "md" | "lg";
  designContest?: boolean;
}) => {
  const { t } = useTranslation();
  const meta =
    status === PortalLifecycleStatus.Open && stage === CompetitionStageDto.InterestOpen
      ? { color: "green", key: "Open for expressions of interest" }
      : status === PortalLifecycleStatus.Open && stage === CompetitionStageDto.RequestsOpen
      ? { color: "green", key: "Open for requests" }
      : status === PortalLifecycleStatus.Open && stage === CompetitionStageDto.Qualification
        ? { color: "blue", key: "Qualification in progress" }
        : status === PortalLifecycleStatus.Open && designContest
          ? { color: "green", key: "Open for entries" }
          : META[status];
  return (
    <Tag variant="outline" colorScheme={meta.color} size={size}>
      {t(meta.key)}
    </Tag>
  );
};
